export default {
    defaultModalStyle: {
        content: {
            top: `50%`,
            left: `50%`,
            right: `auto`,
            bottom: `auto`,
            marginRight: `-50%`,
            transform: `translate(-50%, -50%)`,
            height: `auto`,
            width: `auto`,
            maxWidth: `70%`,
            overflow: `auto`,
            padding: `20px`
        }
    },
    largerModalStyle: {
        content: {
            top: `50%`,
            left: `50%`,
            right: `auto`,
            bottom: `auto`,
            marginRight: `-50%`,
            transform: `translate(-50%, -50%)`,
            height: `auto`,
            width: `auto`,
            overflow: `auto`,
            padding: `20px`
        }
    }
};
